import {Box} from "@unibuddy/patron";
import React from "react";

export const FooterContainer = ({children}) => {
    return <Box paddingX={["xsmall", "small"]}>{children}</Box>;
};
